import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { TrackingData } from '@hdms/shared/common-types';

import { TRACKING_STORAGE_NAME } from '../../analytics';
import { StorageService, StorageType } from '../../storage/storage.service';

export const resolveStoredTrackingData: ResolveFn<TrackingData> = () => {
  const storageService = inject(StorageService);
  const trackingData = storageService.getItem(TRACKING_STORAGE_NAME, StorageType.SESSION, true);
  storageService.removeItem(TRACKING_STORAGE_NAME, StorageType.SESSION, true);

  return trackingData || ({} as TrackingData);
};
